import { DataOptions, DataTableHeader } from 'vuetify'

// eslint-disable-next-line @typescript-eslint/ban-types
export type Prop<T> = { (): T } | { new(...args: never[]): T & object } | { new(...args: string[]): Function }

export type PropType<T> = Prop<T> | Prop<T>[]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface PropOptions<T=any> {
  type?: PropType<T>;
  required?: boolean;
  default?: T | null | undefined | (() => T | null | undefined);
  validator?(value: T): boolean;
}

export type PropValidator<T> = PropOptions<T> | PropType<T>

export interface Civilite {
  value: string
  text: string
}

export type CiviliteType = 'MR' | 'MME'

export const civilites: CiviliteType[] = ['MME', 'MR']

export type LangueType = 'Français' | 'English'

export type AddressType = 'DEFAUT' | 'CONTACT' | 'COMPTABLE' | 'EVENEMENT'
export interface Phone {
  id?: number
  display?: string
  number: string
  valid?: boolean
}
export interface Address {
  id?: number
  address: string
  type: AddressType | ''
  zip: string
  town: string
  country: string
  comment: string
  invalid: boolean|undefined,
  createdTime?: Date
  updatedTime?: Date
}

export type PaymentZone = 'IBAN' | 'SWIFT'
export type PaymentTerm = 'HUNDRED' | 'FIFTYFIFTY'
export type PaymentMethod = 'VIREMENT' | 'CHEQUE' | 'GALOP'

export type RegimeType = 'FR' | 'NO_TVA' | 'CEE' | 'HORS_CEE'
export type ModeType = 'CEE' | 'HORS_CEE'

export type FonctionType = 'COUR' | 'ELEV' | 'ENTR' | 'FOUR' | 'JOUR' | 'PINH' | 'PROP' | 'RESP' | 'TRAN' | 'VETO'

export interface Pageable {
  page: number
  size: number
  sort?: string[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Page<T=any> extends Pageable {
  content: T[]
  totalElements: number
  totalPages: number
}

export const defaultPage : Page<unknown> = {
  content: [],
  page: -1,
  size: -1,
  totalElements: -1,
  totalPages: -1,
}

export interface Email {
  id?: number
  email: string
  type: AddressType
  createdTime?: Date
  updatedTime?: Date
}

export interface Data<T> {
  data: T
}

export type SaleSubscriptionType = 'ELEVAGE' | 'STORE23' | 'CAE' | 'DEUXANS' | 'YEARLING' | 'ETALON' | 'PART_ETALON'

export interface SaleSubscription {
  id: number,
  technicalSaleId: number,
  startDate: string,
  endDate: string,
  type: SaleSubscriptionType
}

// type Months = 'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER'
export interface Month {
  value: string
  text: string
}
export const displayMonths: Month[] = [
  { 'value': 'JANUARY', 'text': 'Janvier' },
  { 'value': 'FEBRUARY', 'text': 'Février' },
  { 'value': 'MARCH', 'text': 'Mars' },
  { 'value': 'APRIL', 'text': 'Avril' },
  { 'value': 'MAY', 'text': 'Mai' },
  { 'value': 'JUNE', 'text': 'Juin' },
  { 'value': 'JULY', 'text': 'Juillet' },
  { 'value': 'AUGUST', 'text': 'Août' },
  { 'value': 'SEPTEMBER', 'text': 'Septembre' },
  { 'value': 'OCTOBER', 'text': 'Octobre' },
  { 'value': 'NOVEMBER', 'text': 'Novembre' },
  { 'value': 'DECEMBER', 'text': 'Décembre' }]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ExtendedDataTableHeader<T extends any = any> extends DataTableHeader<T> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueGetter?: (item: T) => any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueMapper?: (field: any) => any
  onClick?: (item: T) => void
  to?: (item: T) => string | Location
}

export function getMonthLabel(key: string | number | undefined): string | undefined {
  if (typeof key === 'number') {
    return displayMonths[key].text
  } else {
    return key ? displayMonths.find(m => m.value === key)?.text : undefined
  }
}

export function mapDataOptionsToPageable(options: DataOptions): Pageable {
  const sort = options.sortBy.map((el, i) => `${el},${options.sortDesc[i] ? 'DESC' : 'ASC'}`)
  return {
    page: options.page - 1,
    size: options.itemsPerPage,
    sort,
  }
}

export function formatLotNumber(number: number | undefined, supplementRank: number): string {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')
  if (number) {
    return number.toString() + (supplementRank > 0 ? alphabet[supplementRank - 1] : '')
  } else {
    return ''
  }
}

export type Wrapper<T> = { value?: T }
